<template>
  <div class="picmanger">
    <div class="rightmouse"
         :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px' ,opacity : rightMouseFlag ? '1' : '0'}">
      <p>© 图片版权保护</p>
    </div>
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作流</el-breadcrumb-item>
          <el-breadcrumb-item>浏览工作圈</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main"
         v-loading="isRefresh">
      <div class="head">
        <h4>浏览工作圈</h4>
        <!-- <p>+新增用户</p> -->
        <div style="display:flex;align-items: center;width:250px;">
          <p style="margin-right:15px;">工作圈:</p>
          <!-- 征稿活动 -->
          <el-select v-model="activity"
                     style="width:70%;margin-right:10px;"
                     filterable
                     @change="workSearch"
                     placeholder="不限">
            <el-option v-for="item in activityList"
                       :key="item.value + '-3'"
                       :label="item.label"
                       :value="item.value"
                       v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
          </el-select>

          <!-- <div class="choosepicselect">
            <el-dropdown @command="handleCommand">
              <div class="el-dropdown-link mychoose">
                <img src="@/assets/solicitationactivities/folder.png"
                    alt="">
                已选中{{choosePicList.length}}张
                <i class="el-icon-caret-bottom el-icon--right"></i>
              </div>
              <el-dropdown-menu style="width:190px;"
                                slot="dropdown">
                <el-dropdown-item command="a">创建图集</el-dropdown-item>
                <el-dropdown-item command="b">加入图集</el-dropdown-item>
                <el-dropdown-item v-if="choosePicList.length > 0"
                                  command="c">查看图片</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
        </div>
      </div>

      <div class="search">
        <!-- 征稿活动 -->
        <!-- <p style="margin-right:15px;">活动标题:</p> -->
        <!-- 征稿活动 -->
        <!-- <el-select v-model="activity"
                   style="width:20%"
                   filterable
                   clearable
                   placeholder="不限">
          <el-option v-for="item in activityList"
                     :key="item.value + '-3'"
                     :label="item.label"
                     :value="item.value"></el-option>
        </el-select> -->

        <!-- 审核 -->
        <!-- <p style="margin: 0 15px;">审核:</p> -->
        <!-- 审核 -->
        <!-- <el-select v-model="isCheck"
                   filterable
                   clearable
                   placeholder="不限">
          <el-option v-for="item in isCheckList"
                     :key="item.value + '-2'"
                     :label="item.label"
                     :value="item.value"></el-option>
        </el-select>

        <el-button style="margin: 0 15px;"
                   @click="searchClick"
                   class="btn">搜索</el-button> -->

      </div>

      <div class="bigbj"
           style="margin-bottom: 100px;">
        <div class="tablebg"
             :style="e.openClose=='关闭'?'height:800px;':''"
             v-for="(e,i) in listPictureActivity"
             :key="i">
          <div class="head disflex">
            <div class="left disflex">
              <div>{{e.createAtMy}}</div>
              <div style="margin-left:25px;font-size:17px;font-weight:bold;color:rgba(51,51,51,1);"
                   :title="e.title">{{e.title.length > 8  ? e.title.slice(0,8) + '...' : e.title}}</div>
              <!-- <div style="font-size:12px; margin-left:50px;"
                   :title="e.actName"> <span style="font-weight:bolder;">分享名：</span> {{(e.actName.length > 8 ? e.actName.slice(0,8) + '...' :  e.actName) || '暂无'}}</div> -->
              <div style="font-size:12px; margin-left:26px;display: flex;justify-content: center;align-items: center;">
                <span style="font-weight:bolder;">分享者：</span>
                <span slot="reference">{{e.userName || '暂无'}}</span>

                <!-- <el-popover
                  placement="right"
                  title="基本信息"
                  width="200"
                  trigger="click">
                  <p v-if="userInfo.realName" class="tipck">真实姓名：{{userInfo.realName}}</p>
                  <p v-else class="tipck">昵称：{{userInfo.name}}</p>
                  <p class="tipck">手机号：{{userInfo.mobile}}</p>
                  <p class="tipck">邮箱：{{userInfo.email}}</p>
                  <span @click="seeInfoClick(e.createUserInfo.id)" style="color:#185ED3;cursor: pointer;" slot="reference">{{e.actUser || '暂无'}}</span>
                </el-popover>
                
                <img v-if="e.createUserInfo.authStatus == 1" style="margin-left:4px;" src="@/assets/solicitationactivities/auth.png" alt=""> -->
              </div>
              <div style="font-size:12px; margin-left:26px;"> <span style="font-weight:bolder;">图片张数：</span> {{e.pictureCount || '0'}}张</div>
            </div>
            <div class="right disflex">
              <div :style="{'backgroundColor': isSimple ? '#E27B02' : '#194897'}"
                   @click="seeInf(e)">
                <img src="@/assets/solicitationactivities/see.png"
                     alt="">
                <div>查看备注</div>
              </div>
              <div v-if="e.pictureCount > 6"
                   style="background: #00BB1A;"
                   @click="getBigSpace(e,i)">
                <img src="@/assets/solicitationactivities/see.png"
                     alt="">
                <div>{{e.openClose}}</div>
              </div>
              <!-- <div style="background: #00BAFF;"
                   @click="checkClicksh(e.id)"
                   v-if="e.isCheck === 0">
                <img src="@/assets/solicitationactivities/check.png"
                     alt="">
                <div>通过</div>
              </div>
              <div style="background: #FF5105;"
                   @click="checkClickrefuse(e.id)"
                   v-if="e.isCheck === 0 || e.isCheck === 1">
                <img src="@/assets/solicitationactivities/discheck.png"
                     alt="">
                <div>拒绝</div>
              </div>

              <div style="background: #FF8C05;"
                   @click="putIn(e)"
                   v-if="e.status !== 1 && e.isCheck === 1">
                <img src="@/assets/solicitationactivities/add.png"
                     alt="">
                <div>创建图集</div>
              </div>
              <div style="background: #00BB1A;"
                   @click="addIn(e)"
                   v-if="e.status !== 1 && e.isCheck === 1">
                <img src="@/assets/solicitationactivities/goin.png"
                     alt="">
                <div>加入图集</div>
              </div> -->
              <div style="background: #00C590;"
                   @click="useGao(e)">
                <img src="@/assets/solicitationactivities/edit.png"
                     alt="">
                <div>用稿</div>
              </div>
            </div>
          </div>

          <div :ref="'tablebgbody' + i"
               v-if="e.openClose=='展开'"
               class="tablebgbody">
            <div @click="actLeft(i)"
                 v-if="e.pictureCount > 7 "
                 class="left">
              <img src="@/assets/picbrowse/leftjt.png"
                   width="20px"
                   alt />
            </div>

            <div :ref="'actimg' + i"
                 class="actimg">
              <!-- @click="e.isCheck === 1 && ce.atlasId === 0 && openDialog(ci,ce,e,i)" -->
              <div class="imgs"
                   @click.stop="seePic(ci,ce,e,i)"
                   v-for="(ce,ci) in e.pictureInfo"
                   :key="ci">
                <img :src="ce.fileInfo.scr"
                     @contextmenu.prevent="rightShow($event)"
                     ondragstart="return false;"
                     :title="ce.id"
                     height="110px"
                     alt />

                <!-- 修改图片信息 -->
                <!-- <el-tooltip class="item"
                            effect="dark"
                            content="修改图片说明"
                            placement="top">
                  <div v-if="e.isCheck === 1 && ce.atlasId === 0"
                       @click.stop="openChangeDesc(ce)"
                       class="changedesc">
                    <img src="@/assets/sreenpic/desc.png"
                         alt="">
                  </div>
                </el-tooltip> -->

                <!-- 查看图片 -->
                <el-tooltip class="item"
                            effect="dark"
                            content="选用图片"
                            placement="top">
                  <div @click.stop="openDialog(ci,ce,e,i)"
                       v-if="ce.errortext !== 'error' && ( powersObj.selectPicture || ce.fileInfo.picThumbH160 !== 'error') && ce.fileInfo.picThumbH160 !== ''"
                       class="seePic">
                    <img v-if="loveList.indexOf(ce.id) === -1"
                         src="@/assets/piclist/love.png"
                         alt />
                    <img v-if="loveList.indexOf(ce.id) > -1"
                         src="@/assets/piclist/lovec.png"
                         alt />
                  </div>
                </el-tooltip>

                <!-- 选中图片 -->
                <!-- <img v-show="ce.isChoose"
                     class="choosepic"
                     src="@/assets/solicitationactivities/choose.png"
                     alt=""> -->

                <!-- 已入库 -->
                <!-- <div v-if="ce.atlasId !== 0"
                     class="yrk">
                  已入库
                </div> -->
              </div>
            </div>

            <div @click="actRight(i)"
                 v-if="e.pictureCount > 7"
                 class="right">
              <img src="@/assets/picbrowse/rightjt.png"
                   width="20px"
                   alt />
            </div>
          </div>
          <div v-else
               class="tablebgbodyFlex">
            <div :ref="'actimg' + i"
                 class="actimg">
              <!-- @click="e.isCheck === 1 && ce.atlasId === 0 && openDialog(ci,ce,e,i)" -->
              <div class="imgs"
                   @click.stop="seePic(ci,ce,e,i)"
                   v-for="(ce,ci) in e.pictureInfo"
                   :key="ci">
                <img class="img"
                     :src="ce.fileInfo.scr"
                     @contextmenu.prevent="rightShow($event)"
                     ondragstart="return false;"
                     :title="ce.id"
                     alt />
                <!-- 查看图片 -->
                <el-tooltip class="item"
                            effect="dark"
                            content="选用图片"
                            placement="top">
                  <div @click.stop="openDialog(ci,ce,e,i)"
                       v-if="ce.errortext !== 'error' && ( powersObj.selectPicture || ce.fileInfo.picThumbH160 !== 'error') && ce.fileInfo.picThumbH160 !== ''"
                       class="seePic">
                    <img v-if="loveList.indexOf(ce.id) === -1"
                         src="@/assets/piclist/love.png"
                         alt />
                    <img v-if="loveList.indexOf(ce.id) > -1"
                         src="@/assets/piclist/lovec.png"
                         alt />
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>

        <div v-if="listPictureActivity.length === 0 "
             style="display: flex;align-items: center;justify-content:center;height:600px;">
          <img src="@/assets/piclist/nonr.png"
               alt />
        </div>
      </div>

      <div class="pagination">
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="pageSize"
                       layout="prev, pager, next"
                       :total="total"></el-pagination>
      </div>
    </div>

    <changedescdialog :message="message"
                      :dialogVisible="descdialogVisible"
                      @handleClose="deschandleClose"
                      @changeDesc="changeDesc"></changedescdialog>

    <!-- 备注信息 -->
    <el-dialog :visible.sync="dialogVisibleInf"
               width="40%"
               :before-close="handleCloseInf">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>备注信息</div>
      </div>
      <div style="text-align:center;margin-bottom:20px;font-size:30px;font-weight:bold;">{{actInf.title}}</div>

      <div v-if="actInf.content"
           style="height:500px;overflow-y:auto;"
           v-html="actInf.content"></div>
      <div v-if="!actInf.content"
           style="height:300px;overflow-y:auto;">暂无内容</div>
    </el-dialog>

    <!-- 稿件入库 -->
    <el-dialog :visible.sync="dialogVisiblePutIn"
               width="26%"
               class="ruku"
               :before-close="handleClosePutIn">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>稿件入库</div>
      </div>
      <!-- <div class="curtain">
        <div @click="uploadMode = true" :class="{'active' : uploadMode}">创建新图集</div>
        <div @click="uploadMode = false" :class="{'active' : !uploadMode}">归档到图集</div>
      </div> -->
      <div v-if="uploadMode"
           class="nr">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="95px"
                 class="demo-ruleForm"
                 v-loading="dialogLoading">
          <el-form-item label="归属图库:"
                        prop="region">
            <el-cascader
                      style="width: 100%;"
                      v-model="ruleForm.region"
                      :options="libList"></el-cascader>
            <!-- <el-select v-model="ruleForm.region"
                       style="width:100%;"
                       placeholder="请选择图片库">
              <el-option v-for="item in libList"
                         :key="item.value + '-0'"
                         :label="item.label"
                         :value="item.value"
                         v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="图集名:"
                        prop="name">
            <el-input v-model="ruleForm.name"
                      placeholder="请输入图集名"></el-input>
          </el-form-item>
          <el-form-item label="可见性:"
                        prop="status">
            <el-radio-group v-model="ruleForm.status"
                            :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                            size="small">
              <el-radio-button label="0">私密</el-radio-button>
              <el-radio-button label="1">公开</el-radio-button>
            </el-radio-group>
            <!-- <el-select
              style="width:100%;"
              v-model="ruleForm.status"
              placeholder="请选择"
            >
              <el-option
                v-for="item in visibilityList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
          </el-form-item>

          <el-form-item label="备注:"
                        prop="desc">
            <el-input type="textarea"
                      :autosize="{ minRows: 8, maxRows: 12}"
                      v-model="ruleForm.desc"
                      placeholder="选填，备注不超过200个字"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="!uploadMode"
           class="zhidingnr">
        <el-form label-width="95px"
                 v-loading="dialogLoading">
          <el-form-item label="指定图集:">
            <div @click.stop
                 class="inputlist">
              <el-input class="elinput"
                        style="width:100%;"
                        v-model="myselect"
                        placeholder="请输入关键字进行筛选"
                        @input="myLibChange">
              </el-input>
            </div>
          </el-form-item>

          <el-table ref="multipleTable"
                    :data="myAtlas"
                    stripe
                    height="400"
                    @row-click="rowClick"
                    highlight-current-row
                    style="width: 100%;overflow-y: auto;">
            <el-table-column prop="name"
                             show-overflow-tooltip
                             label="图集名">
            </el-table-column>
            <el-table-column prop="date"
                             label="创建时间">
            </el-table-column>

          </el-table>
        </el-form>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button :disabled="dialogLoading"
                   @click="handleClosePutIn">取 消</el-button>
        <el-button :disabled="dialogLoading"
                   type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="subPutIn">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 用稿 -->
    <el-dialog :visible.sync="dialogVisibleMan"
               width="30%"
               class="clearMar"
               :before-close="handleCloseMan">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>用稿</div>
      </div>
      <div class="drawerbtn">
        <div>
          <div class="btnbj">
            <el-button v-if="powersObj.pictureDownload"
                       @click="downloadFlag = true"
                       class="btt">打包下载</el-button>
          </div>
          <!-- <br> -->
          <!-- <div class="btnbj">
            <el-button v-if="powersObj.pictureShare" @click="shareFlag = true" class="btt">分享</el-button>
          </div> -->
          <!-- <br> -->
          <!-- <div class="btnbj">
            <el-button v-if="powersObj.picturePush"
                       @click="pushFlag = true"
                       class="btt">推送</el-button>
          </div> -->
        </div>

        <transition name="el-fade-in-linear">
          <div v-if="downloadFlag"
               class="download"
               @click="downloadFlag = false">
            <div @click.stop
                 style="width:400px;margin:45px auto;">
              <el-input placeholder="请输入打包标题"
                        v-model="downloadTitle">
                <el-button @click.stop="downloadPic"
                           slot="append">打包下载</el-button>
              </el-input>
            </div>
          </div>
        </transition>

        <transition name="el-fade-in-linear">
          <div v-if="shareFlag"
               class="share"
               @click="shareFlag = false">
            <div @click.stop
                 style="width:400px;margin:110px auto;">
              <el-input placeholder="请输入分享标题"
                        v-model="shareTitle">
                <el-button @click.stop="sharePic"
                           slot="append">分享</el-button>
              </el-input>
            </div>
          </div>
        </transition>

        <transition name="el-fade-in-linear">
          <div v-if="pushFlag"
               class="push"
               @click="pushFlag = false">
            <div style="width:430px;margin:30px auto 0;">
              <p>推送至</p>
              <div class="pushbj">
                <div @click.stop="choosePush(i,e.template,e.name,e.id)"
                     :class="pushIndex === i?isSimple ?  'pushlist simpleactive' : 'pushlist active':'pushlist'"
                     v-for="(e,i) in pushList"
                     :key="i">
                  {{e.name}}
                  <img v-if="pushIndex === i"
                       src="@/assets/house/checkInside.png"
                       alt />
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </el-dialog>

    <!-- 推送至图片邀约 -->
    <el-dialog width="26%"
               :before-close="handleClosePic"
               :visible.sync="mydialogVisible">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至图片邀约</div>
      </div>
      <el-form :model="myform"
               ref="myform"
               label-width="70px"
               :rules="rulesyy">
        <!-- <el-form-item v-if="isSee" label="渠道名称：" prop="name">
            <el-input v-model="myform.name" placeholder="必填，2-10个字"></el-input>
        </el-form-item>-->
        <el-form-item label="标题："
                      prop="name">
          <el-select style="width:100%;"
                     @change="myformChange"
                     v-model="myform.name"
                     placeholder="请选择姓名">
            <el-option v-for="(e,i) in picInviteList"
                       :key="i"
                       :label="e.title"
                       :value="e.title"
                       v-html="'<span style=color:#303030;>'+e.title+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">备注：</div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="myform.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClosePic">取 消</el-button>
        <el-button type="primary"
                   v-if="!isClick"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitPic('myform')">提 交</el-button>
        <el-button type="primary"
                   v-else
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   disabled>提 交</el-button>
      </div>
    </el-dialog>

    <!-- 图片点击弹窗 -->
    <el-dialog :visible.sync="dialogVisiblePicInfo"
               class="picSee"
               width="90%"
               top="12vh"
               :show-close="false">
      <!-- 关闭按钮 -->
      <div @click="dialogVisiblePicInfo = false"
           class="close">
        <img :style="{'margin-top':displayResolution < 1600 ? '-2px':'0px'}"
             src="@/assets/picbrowse/close.png"
             alt />
      </div>

      <div class="left">
        <div class="pic"
             v-loading="imgLoading"
             element-loading-text="正在加载图片中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
          <div class="imgBj"
               ref="imgBj">
            <img ref="imgPic"
                 height="98%"
                 @contextmenu.prevent="rightShow($event)"
                 ondragstart="return false;"
                 @click="seeBigSmall"
                 v-lazy="choosePicMsg.src">
            <div @click="bigLeft"
                 class="leftjt">
              <div class="message"
                   v-show="showMessageLeft">这是第一张哟~</div>
            </div>
            <div @click="bigRight"
                 class="rightjt">
              <div class="message"
                   v-show="showMessageRight">这是最后一张哟~</div>
            </div>
            <i @click="picRotateRight"
               v-if="seeFull"
               class="el-icon-refresh-right"
               style="  position:absolute; bottom:20px; left:45%; font-size: 30px;"></i>
            <i @click="picRotateLeft"
               v-if="seeFull"
               class="el-icon-refresh-left"
               style="position:absolute; bottom:20px;font-size: 30px;"></i>
          </div>
          <!-- <img height="78%" :src="choosePicMsg.src"> -->

          <!-- <div class="picBtn">
            <i @click="picRotateRight"
               class="el-icon-refresh-right"></i>
            <i @click="picLarge"
               class="el-icon-zoom-in"></i>
            <i @click="picSmall"
               class="el-icon-zoom-out"></i>
            <i @click="picRotateLeft"
               class="el-icon-refresh-left"></i>
          </div> -->
        </div>

        <div class="picinf disflex">
          <!-- <p class="picinfleft">{{atlasInfo.name}} / 共<span>{{atlasInfo.pictureCount}}</span>张</p> -->
          <!-- <div class="picinfright disflex">
            <div v-if="powersObj.createAtlas" @click.stop="lovePic" class="disflex spare" :style="{background: !haslovechange ?'url('+ require('@/assets/picbrowse/spare.png') +') no-repeat':'url('+ require('@/assets/picbrowse/sparelove.png') +') no-repeat'}">
              <div class="icon"></div>
              
              <p>选用</p>
            </div>
            <div v-if="powersObj.createAtlas" @click="setIndexPic" class="disflex book">
              <div class="icon"></div>
              
              <p>设为封面</p>
            </div>
            <div v-if="powersObj.createAtlas" @click="deletePic" class="disflex delete">
              <div class="icon"></div>
              
              <p>删除</p>
            </div>
          </div>-->
        </div>

        <div ref="piclist"
             class="piclist">
          <div v-if="picAllListFlag >= 13 || scroll < -1"
               @click="smallLeft"
               class="leftjt">
            <i style="font-size:30px;"
               class="el-icon-arrow-left"></i>
          </div>

          <div ref="picalllist"
               style="display:flex;transition:1s;">
            <div @click="picListClick(e,i)"
                 v-for="(e,i) in picList"
                 :key="i">
              <!-- <img :src="e.src" :class="picAllListFlag === i || choosePicMsg.id === i ? 'picimg active':'picimg'" /> -->
              <div :style="{backgroundImage:'url(' + e.fileInfo.Wh160 + ')',cursor:'pointer'}"
                   @contextmenu.prevent="rightShow($event)"
                   ondragstart="return false;"
                   :class="picAllListFlag === i || choosePicMsg.myId === i ? 'picimg active':'picimg'"></div>
            </div>
          </div>

          <div v-if="picCha !== scroll && picList.length > 13"
               @click="smallRight"
               class="rightjt">
            <i style="font-size:30px;"
               class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="title">
          <p>图片信息</p>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">拍摄时间</div>：
          <span>{{picExif.CreateAtMy || '无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">投稿时间</div>：
          <span>{{picInfo.createAt || '无'}}</span>
        </div>
        <div v-if="!picExif.CreateAtMy"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">上传时间</div>：
          <span>{{picInfo.createAt || '无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">相机品牌</div>：
          <span>{{picExif.Make || '暂无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片尺寸</div>：
          <span>{{ picInfo.picW !== '暂无' ? picInfo.picW + '*' + picInfo.picH + '像素' :'暂无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片大小</div>：
          <span>{{picInfo.fileSize}}MB</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片格式</div>：
          <span>{{picInfo.format}}</span>
        </div>
        <div v-if="picExif.ExposureTime"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">曝光时间</div>：
          <span>{{picExif.ExposureTime}}秒</span>
        </div>
        <div v-if="!picExif.ExposureTime"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">曝光时间</div>：
          <span>暂无</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">ISO速度</div>：
          <span>{{picExif.ISOSpeedRatings || '暂无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片焦距</div>：
          <span>{{picExif.FocalLength || '暂无'}}</span>
        </div>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.desc">
          <p>图片说明</p>
        </div>

        <p style="line-height:26px;padding-left:8px;">{{choosePicMsg.desc}}</p>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.labels.length > 0 && !isSimple">
          <p>智能标签</p>
          <div class="alert">仅供参考</div>
        </div>

        <div v-if="!isSimple"
             style="display:flex;align-items: center;flex-wrap: wrap;width:100%;margin-top:10px;">
          <div style="margin-left:5px;margin-bottom:5px;"
               v-for="(e,i) in choosePicMsg.labels"
               :key="i">
            <el-tag>{{e}}</el-tag>
          </div>
        </div>

        <div class="msg disflex"
             v-if="false">
          <div class="picmsg">
            <p>{{choosePicMsg.shareCount}}</p>
            <div>浏览量</div>
            <img src="@/assets/picbrowse/see.png"
                 alt />
          </div>
          <div class="picmsg">
            <p>{{choosePicMsg.pushCount}}</p>
            <div>推送量</div>
            <img src="@/assets/picbrowse/msgpush.png"
                 alt />
          </div>
          <div class="picmsg">
            <p>{{choosePicMsg.downloadCount}}</p>
            <div>平台数</div>
            <img src="@/assets/picbrowse/platform.png"
                 alt />
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 查看所选中的图片 -->
    <!-- <el-dialog title="选中图片"
               :visible.sync="dialogVisibleChosePic"
               width="60%"
               :before-close="handleCloseChosePic">
      <div class="csepic">
        <div class="pic"
             v-for="(e,i) in choosePicList"
             :key="i"
             :style="{backgroundImage:'url(' + e.fileInfo.scr +')'}">
          <div class="delete">
            <img @click="onlyOneDel(i)"
                 src="@/assets/container/delete.png"
                 alt="">
          </div>
        </div>

        <div @click="oneDel"
             class="cleanup">
          <img src="@/assets/container/cleanup.png"
               alt="">
          <p>一键清除</p>
        </div>
      </div>
    </el-dialog> -->

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";


import { mypicinvitetable } from "@/components/index";
import { getPicture, addPicture, getPictures, updatePicture } from "@/api/picture";
import { getUser, getUserAuthInfo } from "@/api/user";
import { getFileInfoById } from "@/api/file";
import { listAllowPushChannel } from "@/api/pushChannel";
import { myPictureNeed } from "@/api/pictureNeed";


import { listAccessByUid } from "@/api/workgroup";
import { listPicturePackage } from "@/api/picturePackage";


import {
  listPictureActivityArticle,
  deletePictureActivityArticle,
  setCheck,
  setStatus
} from "@/api/pictureActivityArticle";
import { picPrefix } from "@/constants/piccommon";
import { allowLib, powersObj } from "@/constants/powers";
import { listLib } from "@/api/lib";
import { addAtlas } from "@/api/atlas";
import { addPicturePackage } from "@/api/picturePackage";
import { getDate, formatConversion } from "@/plugins/getdate";
import { listPictureActivity } from "@/api/pictureActivity";
import { searchAtlas } from "@/api/search";
import { getUserSetting, setUserSetting } from '@/api/config'
import { changedescdialog } from '@/components/index'
import { fullScreen, exitFullscreen, checkFull } from "@/plugins/fullScreen";


export default {
  components: { changedescdialog },
  computed: {
    ...mapGetters(["createUid"])
  },
  data () {
    return {


      seeFull: false,
      //权限
      allowLib,
      powersObj,

      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      timeInt: "",
      activity: "",
      status: -1,
      isCheck: -1,
      choosePicList: [],
      //是否是选择的图片入库
      isChoosePic: false,
      isCheckList: [
        {
          value: -1,
          label: "不限"
        },
        {
          value: 0,
          label: "待审核"
        },
        {
          value: 1,
          label: "已通过"
        },
        {
          value: 2,
          label: "不通过"
        }
      ],
      statusList: [
        {
          value: -1,
          label: "不限"
        },
        {
          value: 0,
          label: "未入库"
        },
        {
          value: 1,
          label: "已入库"
        },
        {
          value: 2,
          label: "已用稿"
        }
      ],
      activityList: [],
      warehousingTime: "",
      listPictureActivity: [],

      libList: [],

      picPrefix,
      dialogVisibleInf: false,
      dialogVisiblePutIn: false,
      dialogVisibleMan: false,
      dialogVisiblePicInfo: false,
      actInf: "",

      putinPicIds: [],
      atlasId: "",
      libId: "",
      uploadMode: true,

      //指定图集
      myAtlas: [],
      myselect: '',

      visibilityList: [
        {
          value: "1",
          label: "公开"
        },
        {
          value: "0",
          label: "私密"
        }
      ],

      ruleForm: {
        name: "",
        region: "",
        desc: "",
        status: "0"
      },
      rules: {
        name: [
          { required: true, message: "请输入图集名", trigger: "blur" },
          { min: 1, max: 60, message: "长度在 1 到 60 个字符", trigger: "blur" }
        ],
        region: [
          { required: true, message: "请选择图片库", trigger: "change" }
        ],
        status: [{ required: true, message: "请选择可见性", trigger: "change" }],
        desc: [
          {
            min: 0,
            max: 200,
            message: "长度不得超过200个字符",
            trigger: "blur"
          }
        ]
      },

      downloadFlag: false,
      shareFlag: false,
      pushFlag: false,
      downloadTitle: "",
      shareTitle: "",
      pushTitle: "",
      pushList: [],
      template: "",
      pushIndex: 0,
      pushChannelId: "",
      mydialogVisible: false,

      pictureArray: [],
      pictureString: [],
      picInviteList: [],
      myform: {
        name: "",
        note: "",
        createUid: this.createUid,
        id: ""
      },
      rulesyy: {
        name: [{ required: true, message: "请选择模板", trigger: "change" }]
      },



      //图片浏览
      clickFlag: 0,
      displayResolution: "",
      choosePicMsg: { labels: [] },
      picList: [],
      imgLoading: false, //图片加载
      atlasInfo: {},
      picInfo: {},
      picExif: {},
      picCha: "",
      picAllListFlag: -1,

      scroll: 0,
      isRefresh: false,
      dialogLoading: false,

      picTimes: 1,
      picDeg: 0,

      //图片说明
      descdialogVisible: false,
      message: '',

      //选中的图片
      dialogVisibleChosePic: false,


      //查看用户基本信息
      userInfo: {
        name: '',
        realName: '',
        mobile: '',
        email: ''
      },


      //双击问题处理
      isClick: false,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,

      //选用图片
      loveList: [],

      showMessageLeft: false,
      showMessageRight: false,


      thumb:'original'
    };
  },
  methods: {
    myformChange (val) {
      console.log(val);
      this.myform.name = val.title;
      this.myform.id = val.id;
    },
    getBigSpace (item, index) {
      if (this.listPictureActivity[index].openClose == '展开') {
        this.listPictureActivity[index].openClose = "关闭"
        this.$forceUpdate()
      } else {
        this.listPictureActivity[index].openClose = "展开"
        this.$forceUpdate()
      }
    },
    workSearch (value) {
      this.activity = value
      this.handleCurrentChange(this.currentPage);
      // console.log(value);
    },

    //获取工作圈
    async listAccessByUidAsync (val) {
      let { status, data, message, pagination, errors } = await listAccessByUid(val);
      if (status) {
        this.activityList = []
        for (let i = 0; i < data.length; i++) {
          this.activityList.push({
            value: data[i].workgroupId,
            label: data[i].workgroupInfo.name
          });

        }
        if (this.activityList) {
          this.activity = this.activityList[0].value
        } else {
          this.activity = '暂无'
        }

        this.handleCurrentChange(this.currentPage);

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取活动投稿列表
    async listPicturePackageAsync (val) {
      this.isRefresh = true;
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)
      let {
        status,
        data,
        message,
        pagination, errors
      } = await listPicturePackage(val);
      if (status) {
        // console.log(data);
        this.listPictureActivity = data




        for (let i = 0; i < this.listPictureActivity.length; i++) {
          this.listPictureActivity[i].openClose = '展开'
          this.listPictureActivity[
            i
          ].pictureIdsArray = this.listPictureActivity[i].pictureIds.split(",");
          this.listPictureActivity[i].pictureInfo = [];
          this.listPictureActivity[i].picScroll = 0;

          this.listPictureActivity[i].createAtMy = formatConversion(
            this.listPictureActivity[i].createAt.toString()
          );

          //获取分享人姓名
          let userInfo = await getUser(this.listPictureActivity[i].createUid)
          this.listPictureActivity[i].userName = userInfo.data.name

          let pics = await getPictures({
            ids: this.listPictureActivity[i].pictureIds
          });

          this.listPictureActivity[i].pictureInfo = pics.data;


          //选用图片
          if (picLoveArray) {
            for (let index = 0; index < picLoveArray.length; index++) {
              for (let j = 0; j < this.listPictureActivity[i].pictureInfo.length; j++) {
                if (picLoveArray[index].id === this.listPictureActivity[i].pictureInfo[j].id) {
                  this.listPictureActivity[i].pictureInfo[j].isChoose = true
                  this.loveList.push(this.listPictureActivity[i].pictureInfo[j].id)
                  continue;
                }
              }
            }
          }


          for (
            let j = 0;
            j < this.listPictureActivity[i].pictureInfo.length;
            j++
          ) {
            // this.listPictureActivity[i].pictureInfo[j].isChoose = false
            // for (let z = 0; z < this.choosePicList.length; z++) {
            //   if (this.choosePicList[z].id == this.listPictureActivity[i].pictureInfo[j].id) {
            //     this.listPictureActivity[i].pictureInfo[j].isChoose = true
            //   }
            // }

            if (this.listPictureActivity[i].pictureInfo[j].exif) {
              this.listPictureActivity[i].pictureInfo[j].exif = JSON.parse(this.listPictureActivity[i].pictureInfo[j].exif)
            }
            if (
              !this.listPictureActivity[i].pictureInfo[j].fileInfo.picThumbH160
            ) {
              this.listPictureActivity[i].pictureInfo[j].fileInfo.scr =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo.savepath;
              this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo.savepath;
              this.listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo.savepath;
            } else if (this.listPictureActivity[i].pictureInfo[j].fileInfo.picThumbH160 == 'ERROR') {
              this.listPictureActivity[i].pictureInfo[j].fileInfo.scr = require('@/assets/house/onloadpicerror.png')

              this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 = require('@/assets/house/onloadpicerror.png')

              this.listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 = require('@/assets/house/onloadpicerror.png')

            } else {
              this.listPictureActivity[i].pictureInfo[j].fileInfo.scr =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo
                  .picThumbH160;
              this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo
                  .picThumbWh160;
              this.listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo
                  .picThumbW1080;
            }

            //图片加载失败
            if (!this.listPictureActivity[i].pictureInfo[j].fileInfo) {
              this.listPictureActivity[i].pictureInfo[j].fileInfo.scr = require('@/assets/house/onloadpic.png')
              this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 = require('@/assets/house/onloadpic.png')
              this.listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 = require('@/assets/house/onloadpic.png')
            }
          }

        }

        this.$forceUpdate()
        console.log(this.listPictureActivity);
        this.total = pagination.total;
        this.isRefresh = false;
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false;
      }
    },

    //图片右击
    rightShow (e) {
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },


    seeInfoClick (id) {
      this.getUserAsync(id)

    },
    //获取用户信息
    async getUserAsync (val) {
      let { status, data, message } = await getUser(val);
      if (status) {
        this.userInfo.name = data.name
        this.userInfo.mobile = data.mobile
        this.userInfo.email = data.email
        if (data.authStatus == 1) {
          this.getUserAuthInfoAsync(val)
        }
      } else {
        this.$message.warning('获取用户信息失败')
      }
    },

    //获取用户认证信息
    async getUserAuthInfoAsync (val) {
      let { status, data, message } = await getUserAuthInfo(val);
      if (status) {
        this.userInfo.realName = data.realName
        // this.dialogVisible = true
      } else {
        this.$message.warning('获取用户信息失败')
      }
    },



    seeBigSmall () {
      this.seeFull = !this.seeFull
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      if (this.seeFull) {
        fullScreen(this.$refs.imgBj)
        this.$refs.imgPic.style.cursor = 'zoom-out'
      } else {
        exitFullscreen()
        this.$refs.imgPic.style.cursor = 'zoom-in'
      }
    },
    //选择图片事件
    handleCloseChosePic () {
      this.dialogVisibleChosePic = false
    },
    //一键清除
    oneDel () {
      this.$confirm('确认全部删除吗？', {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.choosePicList = []
          this.setUserSettingAsync(this.createUid, 'chooseWorkList', { value: null })
          this.$message.success('全部删除成功')
          this.dialogVisibleChosePic = false
        })
        .catch(e => {
          // console.log('取消')
        });
    },
    //清除
    onlyOneDel (i) {
      this.$confirm('确认删除吗？', {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.choosePicList.splice(i, 1)
          let idsInfo = []
          for (let k = 0; k < this.choosePicList.length; k++) {
            idsInfo.push({
              id: this.choosePicList[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'chooseWorkList', { value: idsInfo })
          this.$message.success('删除成功')
        })
        .catch(e => {
          // console.log('取消')
        });
    },

    //添加到图集
    async updatePictureAddAsync (val) {
      let { status, data, message } = await updatePicture(val);
      if (status) {
        // this.$message.success("修改成功！")
      }
    },

    //修改图片说明
    changeDesc (val) {
      this.updatePictureAsync(val)
      this.descdialogVisible = false
    },
    deschandleClose () {
      this.descdialogVisible = false
    },
    openChangeDesc (val) {
      // console.log(val)
      this.message = val
      this.descdialogVisible = true
    },
    //修改图片说明
    async updatePictureAsync (val) {
      let { status, data, message, errors } = await updatePicture(val);
      if (status) {
        this.$message.success("修改成功！")
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //换行事件
    turn (data) {
      return data.replace(/\n\n/g, "<br/>");
    },
    turn1 (data) {
      return data.replace(/\n/g, "<br/>");
    },
    //指定图集事件
    myLibChange () {
      // console.log(this.myselect)
      if (!this.myselect) {
        this.myAtlas = []
        this.searchAtlasAsync({ pageSize: 20, page: 0, createUid: this.createUid })
      }
      if (this.myselect.length >= 2) {
        this.myAtlas = []
        this.searchAtlasAsync({ keyword: this.myselect, pageSize: 50, page: 0, createUid: this.createUid })
      }
      // this.myLibId = i.libId
      // this.myAtlasId = i.id
    },

    rowClick (row) {
      this.libId = row.libId
      this.atlasId = row.atlasId
    },


    comPic (val, tt) {
      // console.log(val,tt)
      let choosePicMsg = {
        createUid: this.createUid,
        packageType: val,
        pictureCount: this.pictureArray.length,
        pictureIds: this.pictureString,
        title: tt.name || tt.title || tt,
        pushConfig:
          JSON.stringify({
            pushChannelId: this.pushChannelId,
            pictureNeedId: tt.id,
            note: tt.note
          }) || "",
        downloadConfig: JSON.stringify({ thumb:this.thumb }) || ''
      };

      this.addPicturePackageAsync(choosePicMsg);
    },
    //图片放大
    picLarge () {
      this.picTimes += 1.5
      if (this.picTimes < 6) {
        this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      } else {
        this.picTimes = 6
        this.$refs.imgPic.style.transform = 'scale(6) rotateZ(' + this.picDeg + 'deg)';
      }
    },
    //图片缩小
    picSmall () {
      this.picTimes -= 1.5
      if (this.picTimes > 1) {
        this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      } else {
        this.picTimes = 1
        this.$refs.imgPic.style.transform = 'scale(1) rotateZ(' + this.picDeg + 'deg)';
      }
    },

    //图片旋转
    picRotateLeft () {
      this.picDeg -= 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    //图片旋转
    picRotateRight () {
      this.picDeg += 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    //清除放大缩小效果
    clearLargeAndSmall () {
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
    },

    //滚动加载图片
    scrollPic () {
      let isBottom =
        document.documentElement.scrollTop + window.innerHeight ===
        document.body.offsetHeight;
      if (isBottom) {
        if (this.listPictureActivity.length !== this.total) {
          // this.currentPage++;
          this.handleCurrentChange(this.currentPage + 1)
          // let params = {
          //   page: this.currentPage - 1,
          //   pageSize: this.pageSize,
          //   isCheck: this.isCheck || -1,
          //   status: this.status || -1,
          //   pictureActivityId: this.activity || 0
          // };
          // this.listPictureActivityArticleAsync(params);
        }
      }
    },

    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      let data = {
        page: this.currentPage - 1,
        pageSize: this.pageSize,
        packageType: "share",
        targetWorkgroupId: this.activity
      }

      // console.log(data)
      this.listPicturePackageAsync(data);

      setTimeout(() => {
        window, scrollTo(0, 0)
      }, 1000);
    },

    //刷新表格
    refresh () {
      this.currentPage = 1
      this.handleCurrentChange(this.currentPage);
      // this.status = -1;
      // this.isCheck = -1;
      // if (powersObj.manageAllPictureActivity) {
      //   this.listPictureActivityAsync({ createUid: -1, pageSize: 100 });
      // } else if (powersObj.myPictureActivity) {
      //   this.listPictureActivityAsync({ createUid: 0, pageSize: 100 });
      // }else{
      //   this.$message.warning('获取活动列表失败！')
      // }
    },

    //判断选中的图片在什么位置
    beSurePic (i, num) {
      if (i > num) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        this.scroll = i * -80;
        // console.log(piclistwidth - picalllistwidth)
        // console.log(this.scroll)
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 70;
          this.picCha = this.scroll;
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + ")";
        this.scroll = 0;
      }
    },

    //获取图片信息
    getPicInfo (e) {
      // console.log(e)
      this.picInfo.picH = e.fileInfo.picH || "暂无";
      this.picInfo.picW = e.fileInfo.picW || "暂无";
      this.picInfo.format =
        e.fileInfo.savepath.substring(e.fileInfo.savepath.length - 3) || "jpg";
      this.picInfo.createAt = formatConversion(
        e.fileInfo.createAt.toString()
      ).substring(0, 10);
      if (e.createAt !== 0) {
        this.picInfo.toConCreateAt = formatConversion(
          e.createAt.toString()
        ).substring(0, 10);
      } else {
        this.picInfo.toConCreateAt = ''
      }

      this.picInfo.fileSize =
        (e.fileInfo.fileSize / 1024 / 1024).toFixed(2) || "暂无";

      if (!e.exif) {
        this.picExif = {};
      } else {
        this.picExif = e.exif;
        if (e.exif.CreateAt) {
          if (this.picExif.CreateAt) {
            this.picExif.CreateAtMy = formatConversion(this.picExif.CreateAt.toString()).substring(0, 10)
          } else {
            this.picExif.CreateAtMy = formatConversion(e.exif.CreateAt.toString()).substring(0, 10)
          }
        } else {
          this.picExif.CreateAtMy = null;
        }
      }
    },

    //图片浏览
    seePic (i, e, picList) {
      this.dialogVisiblePicInfo = true;
      this.choosePicMsg = {};
      // console.log(e)
      // e.labels=['风景','运动员','环境','劳作','亲子活动','开会','抗洪抢险','剪裁']
      this.choosePicMsg.id = e.id;
      this.choosePicMsg.labels = e.labels
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.src = e.fileInfo.picW1080;
      this.choosePicMsg.myId = i;
      this.picAllListFlag = i;
      this.picList = picList.pictureInfo;

      this.getPicInfo(e);

      this.$nextTick(() => {
        this.clearLargeAndSmall()
        this.beSurePic(i, 10);
      });
    },

    //选择图片
    openDialog (i, e, be, bi) {
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)

      console.log(this.listPictureActivity[bi].pictureInfo[i].isChoose);

      if (this.listPictureActivity[bi].pictureInfo[i].isChoose) {
        this.listPictureActivity[bi].pictureInfo[i].isChoose = false
        this.loveList.splice(this.loveList.indexOf(e.id), 1)


        if (picLoveArray.length === 1) {
          sessionStorage.removeItem("picLove");
          this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
          this.$message.success("移出成功")
        } else {
          for (let i = 0; i < this.choosePicList.length; i++) {
            if (this.choosePicList[i].id == e.id) {
              this.choosePicList.splice(i, 1)
            }
          }
          let f
          for (let i = 0; i < picLoveArray.length; i++) {
            if (e.id === picLoveArray[i].id) {
              f = i
            }
          }
          picLoveArray.splice(f, 1)
          sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
          let idsInfo = []
          for (let k = 0; k < picLoveArray.length; k++) {
            idsInfo.push({
              id: picLoveArray[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
          this.$message.success("移出成功")
        }

      } else {
        this.listPictureActivity[bi].pictureInfo[i].isChoose = true
        this.loveList.push(e.id)

        if (!picLoveArray) {
          let pL = []
          pL.push(e)
          sessionStorage.setItem("picLove", JSON.stringify(pL));
          this.setUserSettingAsync(this.createUid, 'picLove', { value: e.id })
          this.$message.success("添加成功")
        } else {
          picLoveArray.push(e)
          sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
          let idsInfo = []
          for (let k = 0; k < picLoveArray.length; k++) {
            idsInfo.push({
              id: picLoveArray[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
          this.$message.success("添加成功")
        }
        // console.log(this.choosePicList)
        // this.setUserSettingAsync(this.createUid, 'picLove', { value: JSON.stringify(this.choosePicList) })
      }


      // this.choosePicMsg = {};
      // // console.log(e)
      // this.choosePicMsg.id = e.id;
      // this.choosePicMsg.labels = e.labels
      // this.choosePicMsg.desc = e.desc;
      // this.choosePicMsg.downloadCount = 0;
      // this.choosePicMsg.pushCount = 0;
      // this.choosePicMsg.shareCount = 0;
      // this.choosePicMsg.src = e.fileInfo.picW1080;
      // this.choosePicMsg.myId = i;
      // this.picAllListFlag = i;
      // this.picList = be.pictureInfo;

      // this.getPicInfo(e);


      // console.log(this.listPictureActivity[bi].pictureInfo[i].isChoose)
    },

    //图片浏览中大的箭头 左边
    bigLeft () {
      if (this.choosePicMsg.myId === 0) {
        if (!this.showMessageLeft) {
          this.showMessageLeft = true
          setTimeout(() => {
            this.showMessageLeft = false
          }, 1500);
        }
        return;
      }
      this.clearLargeAndSmall()
      this.choosePicMsg.labels = this.picList[this.choosePicMsg.myId - 1].labels
      this.choosePicMsg.src = this.picList[this.choosePicMsg.myId - 1].fileInfo.picW1080;
      this.choosePicMsg.desc = this.picList[this.choosePicMsg.myId - 1].desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.id = this.picList[this.choosePicMsg.myId - 1].id;

      this.getPicInfo(this.picList[this.choosePicMsg.myId - 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId - 1;
      // console.log(this.choosePicMsg)
      this.picAllListFlag = this.choosePicMsg.myId;
      if (this.choosePicMsg.myId < 10) {
        this.scroll = 0;
        this.picCha = -1;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.scroll = this.scroll + 3 * this.choosePicMsg.myId;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },
    //图片浏览中大的箭头 右边
    bigRight () {
      if (this.choosePicMsg.myId === this.picList.length - 1) {
        if (!this.showMessageRight) {
          this.showMessageRight = true
          setTimeout(() => {
            this.showMessageRight = false
          }, 1500);
        }
        return;
      }
      this.clearLargeAndSmall()
      this.choosePicMsg.labels = this.picList[this.choosePicMsg.myId + 1].labels
      // this.picListClick(this.picList[this.choosePicMsg.id + 1],this.choosePicMsg.id + 1)
      this.choosePicMsg.src = this.picList[this.choosePicMsg.myId + 1].fileInfo.picW1080;
      this.choosePicMsg.desc =
        this.picList[this.choosePicMsg.myId + 1].desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.id = this.picList[this.choosePicMsg.myId + 1].id;

      this.getPicInfo(this.picList[this.choosePicMsg.myId + 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId + 1;
      this.picAllListFlag = this.choosePicMsg.myId;
      // console.log(this.choosePicMsg)
      if (this.choosePicMsg.myId > 10) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        // console.log(this.scroll)
        // console.log(this.choosePicMsg.myId)
        if (this.scroll === 0) {
          this.scroll = this.choosePicMsg.myId * -70;
        } else {
          if (this.choosePicMsg.myId > 50) {
            this.scroll = this.scroll - 2 * this.choosePicMsg.myId;
          } else {
            this.scroll = this.scroll - 3 * this.choosePicMsg.myId;
          }
        }
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 80;
          setTimeout(() => {
            this.picCha = this.scroll;
          }, 1000);
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },
    //图片浏览小的箭头 右边
    smallRight () {
      let picalllistwidth = this.$refs.picalllist.offsetWidth;
      let piclistwidth = this.$refs.piclist.offsetWidth;
      this.scroll = this.scroll - 300;
      if (this.scroll < piclistwidth - picalllistwidth) {
        this.scroll = piclistwidth - picalllistwidth - 70;
        this.picCha = this.scroll;
        // console.log(this.scroll)
      }

      this.$refs.picalllist.style.transform =
        "translateX(" + this.scroll + "px)";
    },
    //图片浏览小的箭头 左边
    smallLeft () {
      this.scroll = this.scroll + 300;
      if (this.scroll > 0) {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + "px)";
        this.scroll = 0;
      } else {
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },

    //图片浏览中图片点击
    picListClick (e, i) {
      this.clearLargeAndSmall()
      this.choosePicMsg.id = e.id;
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.src = e.fileInfo.picW1080;
      this.choosePicMsg.myId = i;
      this.picAllListFlag = i;

      this.getPicInfo(e);
    },

    //搜索
    searchClick () {
      this.listPictureActivity = []
      this.currentPage = 1
      let data = {
        page: 0,
        pageSize: this.pageSize,
        isCheck: this.isCheck,
        status: this.status,
        pictureActivityId: this.activity
      };

      this.listPictureActivityArticleAsync(data);
    },

    //用稿操作
    useGao (e) {
      // console.log(e);
      this.putinPicIds = e
      this.pictureArray = e.pictureIdsArray;
      this.pictureString = e.pictureIds;
      sessionStorage.setItem("actPic", JSON.stringify(e.pictureInfo));
      this.listAllowPushChannelAsync();
      this.dialogVisibleMan = true;
    },
    //图片包操作
    //推送
    pushPic (name) {
      if (this.template === "routersoft-qms") {
        this.handleClose();
        this.$router.push({
          path: "/shareAndPush/push/qms",
          query: {
            isSavePic: this.isSavePic,
            name: name,
            isAct: true,
            pushChannelId: this.pushChannelId
          }
        });
      } else if (
        this.template === "routersoft-rmt" ||
        this.template === "routersoft-mcp"
      ) {
        this.handleClose();
        this.$router.push({
          path: "/shareAndPush/push/mcp",
          query: {
            isSavePic: this.isSavePic,
            name: name,
            isAct: true,
            pushChannelId: this.pushChannelId
          }
        });
      } else if (
        this.template === "picture-need" ||
        this.template === "system-picture-need"
      ) {
        this.listPictureNeedAsync();
        this.mydialogVisible = true;
      }
    },
    handleClosePic () {
      this.mydialogVisible = false;
      // this.clearData()
    },
    //推送选择
    choosePush (i, t, name, id) {
      this.pushIndex = i;
      this.template = t;
      this.pushChannelId = id;
      this.pushPic(name);
    },
    //图片tuo
    submitPic (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.isClick = true
          setTimeout(() => {
            this.isClick = false
          }, 2000);
          this.comPic("push", this.myform);
          this.mydialogVisible = false;
          let params = {
            id: this.putinPicIds.id,
            status: 2
          }
          this.pushSetStatus(params)
          this.$router.push("/shareAndPush/myPush");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose () {
      this.downloadFlag = false;
      this.shareFlag = false;
      this.pushFlag = false;
      this.downloadTitle = "";
      this.shareTitle = "";
      this.pushTitle = "";
    },

    //分享
    sharePic () {
      if (this.shareFlag) {
        if (this.shareTitle == "") {
          this.$message.error("请输入标题！");
        } else {
          this.comPic("share", this.shareTitle);
          this.shareFlag = false;
          this.$router.push("/shareAndPush/myShare");
        }
      }
    },

    //打包下载
    async downloadPic () {
      if (this.downloadFlag) {
        if (this.downloadTitle == "") {
          this.$message.error("请输入标题！");
        } else {
          this.$confirm('请选择下载清晰度!', '提示', {
              distinguishCancelAndClose: true,
              confirmButtonText: '原图',
              cancelButtonText: '低'
            }).then(async() => {
              this.thumb = 'original'
              this.comPic("download", this.downloadTitle);
              this.downloadFlag = false;
              let params = {
                id: this.putinPicIds.id,
                status: 2
              }
              await setStatus(params)
              this.$router.push("/shareAndPush/myDownload");
            }).catch(async (action)  => {
              if(action === 'cancel'){
                this.thumb = 'small'
                this.comPic("download", this.downloadTitle);
                this.downloadFlag = false;
                let params = {
                  id: this.putinPicIds.id,
                  status: 2
                }
                await setStatus(params)
                this.$router.push("/shareAndPush/myDownload"); 
              }
                     
            });
        }
      }
    },
    async pushSetStatus (val) {
      await setStatus(params)
    },

    handleCommand (command) {
      if (this.choosePicList.length == 0) {
        this.$message.warning('请选择图片！')
        return false;
      }
      if (command == 'a') {
        this.putInChoose()
        this.isChoosePic = true
      }
      if (command == 'b') {
        this.addInChoose()
        this.isChoosePic = true
      }
      if (command == 'c') {
        this.dialogVisibleChosePic = true
      }
    },

    //创建图集
    putInChoose () {
      // console.log(1)
      this.uploadMode = true
      this.libList = []
      this.listLibAsync();
      this.putinPicIds = this.choosePicList;
      this.dialogVisiblePutIn = true;
    },
    //加入图集
    addInChoose () {
      this.uploadMode = false
      this.libList = []
      this.listLibAsync();
      this.putinPicIds = this.choosePicList;
      this.dialogVisiblePutIn = true;
    },

    //创建图集
    putIn (e) {
      this.uploadMode = true
      this.libList = []
      this.listLibAsync();
      this.putinPicIds = e;
      this.isChoosePic = false
      this.dialogVisiblePutIn = true;
    },
    //加入图集
    addIn (e) {
      this.uploadMode = false
      this.libList = []
      this.listLibAsync();
      this.putinPicIds = e;
      this.isChoosePic = false
      this.dialogVisiblePutIn = true;
    },

    //入库中
    async subPutIn () {
      if (this.uploadMode) {
        this.$refs["ruleForm"].validate(valid => {
          if (valid) {
            this.dialogLoading = true;
            let data = {
              name: this.ruleForm.name,
              desc: this.ruleForm.desc,
              libId: this.ruleForm.region,
              status: this.ruleForm.status,
              sourceType: "0",
              createUid: this.createUid,
              indexpicId: "0"
            };
            this.addAtlasAsync(data);
          } else {
            return false;
          }
        });
      } else {
        if (!this.atlasId) {
          this.$message.warning('请选择图集！')
          return false
        }
        this.dialogLoading = true;


        if (!this.isChoosePic) {
          let e = this.putinPicIds;

          for (let i = 0; i < e.pictureInfo.length; i++) {
            let fId = await getPicture(e.pictureInfo[i].id)
            let picMsg = {
              atlasId: this.atlasId,
              fileId: fId.data.fileId,
              libId: this.libId,
              desc: "",
              createUid: this.createUid,
              tags: ''
            };
            let addPic = await addPicture(picMsg);

            if (addPic.status) {
              if (i === e.pictureInfo.length - 1) {
                this.$message.success("添加图片成功！");
                this.dialogLoading = false;
                this.dialogVisiblePutIn = false;
                this.myselect = ''
                this.atlasId = ''
                this.libId = ''
                let params = {
                  id: this.putinPicIds.id,
                  status: 1
                }
                await setStatus(params)

                setTimeout(() => {
                  this.refresh()
                }, 800);
              }
            }
          }

        } else {
          let e = this.choosePicList;

          for (let i = 0; i < e.length; i++) {
            let picMsg = {
              atlasId: this.atlasId,
              fileId: e[i].fileId,
              id: e[i].id,
              libId: this.libId
            };
            let addPic = await updatePicture(picMsg);

            if (addPic.status) {
              if (i === e.length - 1) {
                this.$message.success("添加图片成功！");
                this.choosePicList = []
                this.setUserSettingAsync(this.createUid, 'chooseWorkList', { value: null })
                this.refresh()
                this.dialogLoading = false;
                this.dialogVisiblePutIn = false;
                this.myselect = ''
                this.atlasId = ''
                this.libId = ''
                this.myAtlas = []
                this.searchAtlasAsync({ pageSize: 20, page: 0, createUid: this.createUid })

                // setTimeout(() => {
                //   this.$message.success('即将为您跳转到个人图集')
                //   setTimeout(() => {
                //     this.$router.push('/personpicindex')
                //   }, 1000);
                // }, 2000);
              }
            }
          }

        }




      }

    },

    //查看活动征稿的内容
    seeInf (e) {
      this.actInf = e;
      if (this.actInf.shareConfig) {
        this.actInf.content = JSON.parse(this.actInf.shareConfig).note
      } else {
        this.actInf.content = ''
      }

      // this.actInf.content = this.turn(this.actInf.content)
      // this.actInf.content = this.turn1(this.actInf.content)
      this.dialogVisibleInf = true;
    },

    checkClicksh (id) {
      this.$confirm("确认审核通过吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.setCheckAsync({ id, isCheck: 1, message: '' });
        })
        .catch(e => { });
    },
    checkClickrefuse (id) {
      this.$prompt('拒绝理由：', '拒绝', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.setCheckAsync({ id, isCheck: 2, message: value });

      })
      // this.$confirm("确认拒绝该稿件吗？")
      //   .then(e => {
      //     this.setCheckAsync({ id, isCheck: 2 });
      //   })
      //   .catch(e => { });
    },
    checkClickfs (id) {
      this.$confirm("确认撤回审核吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.setCheckAsync({ id, isCheck: 0, message: '' });
        })
        .catch(e => { });
    },

    //删除投稿活动
    deleteActArt (e) {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(event => {
          let params = {
            id: e.id,
            status: -99
          }
          this.setStatusAsync(params);
        })
        .catch(event => { });
    },

    handleCloseInf () {
      this.dialogVisibleInf = false;
    },
    handleClosePutIn () {
      // this.uploadMode = true
      this.dialogVisiblePutIn = false;
      this.$refs["ruleForm"].resetFields();
    },
    handleCloseMan () {
      this.dialogVisibleMan = false;
      this.handleClose();
    },

    //向右滚动
    actRight (i) {
      // this.scroll = 0
      let actimgwidth = this.$refs["actimg" + i][0].offsetWidth;
      let tablebgbodywidth = this.$refs["tablebgbody" + i][0].offsetWidth;
      let widthcha = tablebgbodywidth - actimgwidth;
      if (this.listPictureActivity[i].picScroll > widthcha) {
        this.listPictureActivity[i].picScroll += -90;
      }

      this.$refs["actimg" + i][0].style.transform =
        "translateX(" + this.listPictureActivity[i].picScroll + "px)";
      // console.log(this.scroll, this.listPictureActivity[i].picScroll);
    },

    //向左滚动
    actLeft (i) {
      // this.scroll = 0
      let actimgwidth = this.$refs["actimg" + i][0].offsetWidth;
      let tablebgbodywidth = this.$refs["tablebgbody" + i][0].offsetWidth;
      let widthcha = tablebgbodywidth - actimgwidth;
      if (this.listPictureActivity[i].picScroll !== 0) {
        this.listPictureActivity[i].picScroll += 90;
      }
      this.$refs["actimg" + i][0].style.transform =
        "translateX(" + this.listPictureActivity[i].picScroll + "px)";
      // console.log(this.scroll, this.listPictureActivity[i].picScroll);
    },

    //设置审核结果
    async setCheckAsync (val) {
      let { status, data, message, errors } = await setCheck(val);
      if (status) {
        this.$message.success("设置成功！");
        this.handleCurrentChange(this.currentPage);

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    //删除投稿活动
    async setStatusAsync (val) {
      let { status, data, message, errors } = await setStatus(val);
      if (status) {
        this.$message.success("删除成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取征稿活动列表
    async listPictureActivityAsync (val) {
      let { status, data, message, pagination, errors } = await listPictureActivity(val);
      if (status) {
        this.activityList = []
        // this.activityList.push({
        //   value: 0,
        //   label: "不限"
        // });
        for (let i = 0; i < data.length; i++) {
          if (data[i].status === 1) {
            this.activityList.push({
              value: data[i].id,
              label: data[i].title
            });
          }

        }
        if (this.activityList) {
          this.activity = this.activityList[0].value
        } else {
          this.activity = '暂无'
        }

        this.handleCurrentChange(this.currentPage);

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取图片库列表
    async listLibAsync () {
      let { status, data, message, errors } = await listLib();
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
            if (data[i].status === 1) {
              this.libList.push({
                value: data[i].id,
                label: data[i].name,
                children:[]
              });
            }

          }
        }
        for (let i = 0;i < this.libList.length;i++) {
          let flag = 0
          for (let j = 0; j < this.allowLib.length; j++) {
            if(this.allowLib[j].toString().indexOf('-') !== -1){
              if(this.libList[i].value == this.allowLib[j].split('-')[0]){
                flag++
                this.libList[i].children.push({
                  value: this.allowLib[j].split('-')[1],
                  label: ''
                })
              }
            }
            
          }
          if(flag == 0){
            delete this.libList[i].children
          }
        }

        for (let i = 0; i < this.libList.length; i++) {
          if(this.libList[i].hasOwnProperty('children')){
            if(this.libList[i].children.length > 0){
              for (let z = 0; z < this.libList[i].children.length; z++) {
                for (let j = 0; j < data.length; j++) {
                  if(data[j].id == this.libList[i].children[z].value){
                    this.libList[i].children[z].label = data[j].name
                  }
                  
                }
                
              }
              
            }
          }
          
          
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //获取图片邀约列表
    async listPictureNeedAsync () {
      let { status, data, message, pagination, errors } = await myPictureNeed();
      if (status) {
        this.picInviteList = data;

        if (data.length !== 0) {
          this.myform.name = this.picInviteList[0].title;
          this.myform.id = this.picInviteList[0].id;
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取允许的推送渠道
    async listAllowPushChannelAsync () {
      let { status, data, message, errors } = await listAllowPushChannel();
      if (status) {
        this.pushList = data;
        this.template = this.pushList[0].template;
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //增加图片包
    async addPicturePackageAsync (val) {
      let { status, data, message, errors } = await addPicturePackage(val);
      if (status) {
        this.$message.success("添加成功！");
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //创建图集
    async addAtlasAsync (val) {
      let libArr = val.libId
      if(libArr.length >= 2){
        val.parentLibId = parseInt(libArr[0])
        val.libId = parseInt(libArr[1])
      }else{
        val.parentLibId = 0
        val.libId = parseInt(libArr[0])
      }
      let { status, data, message, errors } = await addAtlas(val);
      if (status) {
        this.atlasId = data.id;
        this.libId = data.libId;


        if (!this.isChoosePic) {
          let e = this.putinPicIds;

          for (let i = 0; i < e.pictureInfo.length; i++) {
            let fId = await getPicture(e.pictureInfo[i].id)
            let picMsg = {
              atlasId: data.id,
              fileId: fId.data.fileId,
              libId: data.libId,
              desc: "",
              createUid: this.createUid,
              tags: ''
            };
            let addPic = await addPicture(picMsg);

            if (addPic.status) {
              if (i === e.pictureInfo.length - 1) {
                this.$message.success("创建图集成功！");
                this.dialogLoading = false;
                this.dialogVisiblePutIn = false;
                let params = {
                  id: this.putinPicIds.id,
                  status: 1
                }
                await setStatus(params)
                this.handleCurrentChange(this.currentPage)
                this.refresh()
                this.$refs["ruleForm"].resetFields();
              }
            }
          }
        } else {
          let e = this.choosePicList;

          for (let i = 0; i < e.length; i++) {
            let picMsg = {
              atlasId: data.id,
              fileId: e[i].fileId,
              id: e[i].id,
              libId: data.id
            };
            let addPic = await updatePicture(picMsg);

            if (addPic.status) {
              if (i === e.length - 1) {
                this.$message.success("创建图集成功！");
                this.choosePicList = []
                this.handleCurrentChange(this.currentPage)
                this.refresh()
                this.dialogLoading = false;
                this.dialogVisiblePutIn = false;
                this.$refs["ruleForm"].resetFields();
              }
            }
          }
        }


      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.dialogLoading = false;
      }
    },

    //获取活动投稿列表
    async listPictureActivityArticleAsync (val) {
      this.isRefresh = true;
      let {
        status,
        data,
        message,
        pagination, errors
      } = await listPictureActivityArticle(val);
      if (status) {
        this.listPictureActivity = data;
        // if (this.currentPage === 1) {
        //   this.listPictureActivity = data;
        // } else {
        //   for (let i = 0; i < data.length; i++) {
        //     this.listPictureActivity.push(data[i]);
        //   }
        // }

        this.total = pagination.total;
        for (let i = 0; i < this.listPictureActivity.length; i++) {
          this.listPictureActivity[
            i
          ].pictureIdsArray = this.listPictureActivity[i].pictureIds.split(",");
          this.listPictureActivity[i].pictureInfo = [];
          this.listPictureActivity[i].picScroll = 0;

          this.listPictureActivity[i].createAtMy = formatConversion(
            this.listPictureActivity[i].createAt.toString()
          );

          let pics = await getPictures({
            ids: this.listPictureActivity[i].pictureIds
          });

          this.listPictureActivity[i].pictureInfo = pics.data;

          for (
            let j = 0;
            j < this.listPictureActivity[i].pictureInfo.length;
            j++
          ) {
            this.listPictureActivity[i].pictureInfo[j].isChoose = false
            for (let z = 0; z < this.choosePicList.length; z++) {
              if (this.choosePicList[z].id == this.listPictureActivity[i].pictureInfo[j].id) {
                this.listPictureActivity[i].pictureInfo[j].isChoose = true
              }
            }

            if (this.listPictureActivity[i].pictureInfo[j].exif) {
              this.listPictureActivity[i].pictureInfo[j].exif = JSON.parse(this.listPictureActivity[i].pictureInfo[j].exif)
            }
            if (
              !this.listPictureActivity[i].pictureInfo[j].fileInfo.picThumbH160
            ) {
              this.listPictureActivity[i].pictureInfo[j].fileInfo.scr =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo.savepath;
              this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo.savepath;
              this.listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo.savepath;
            } else if (this.listPictureActivity[i].pictureInfo[j].fileInfo.picThumbH160 == 'ERROR') {
              this.listPictureActivity[i].pictureInfo[j].fileInfo.scr = require('@/assets/house/onloadpicerror.png')

              this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 = require('@/assets/house/onloadpicerror.png')

              this.listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 = require('@/assets/house/onloadpicerror.png')

            } else {
              this.listPictureActivity[i].pictureInfo[j].fileInfo.scr =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo
                  .picThumbH160;
              this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo
                  .picThumbWh160;
              this.listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 =
                picPrefix +
                this.listPictureActivity[i].pictureInfo[j].fileInfo
                  .picThumbW1080;
            }

            //图片加载失败
            if (!this.listPictureActivity[i].pictureInfo[j].fileInfo) {
              this.listPictureActivity[i].pictureInfo[j].fileInfo.scr = require('@/assets/house/onloadpic.png')
              this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 = require('@/assets/house/onloadpic.png')
              this.listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 = require('@/assets/house/onloadpic.png')
            }
          }

          if (this.listPictureActivity[i].createUserInfo) {
            this.listPictureActivity[i].actUser = this.listPictureActivity[i].createUserInfo.name
          } else {
            this.listPictureActivity[i].actUser = '暂无'
          }
          if (this.listPictureActivity[i].activityInfo) {
            this.listPictureActivity[i].actName = this.listPictureActivity[i].activityInfo.title
          } else {
            this.listPictureActivity[i].actName = '暂无'
          }

          // if (this.listPictureActivity[i].pictureCount !== 0) {
          //   for (
          //     let j = 0;
          //     j < this.listPictureActivity[i].pictureIdsArray.length;
          //     j++
          //   ) {
          //     let picInfo = await getPicture(
          //       this.listPictureActivity[i].pictureIdsArray[j]
          //     );
          //     let fileInfo = await getFileInfoById(picInfo.data.fileId);

          //     let listPicAct = { ...fileInfo.data };

          //     if (!fileInfo.data.picThumbH160) {
          //       listPicAct.src = picPrefix + fileInfo.data.savepath;
          //       listPicAct.picThumbWh160 = picPrefix + fileInfo.data.savepath;
          //       listPicAct.picW1080 = picPrefix + fileInfo.data.savepath;
          //     } else {
          //       listPicAct.src = picPrefix + fileInfo.data.picThumbH160;
          //       listPicAct.picThumbWh160 =
          //         picPrefix + fileInfo.data.picThumbWh160;
          //       listPicAct.picW1080 = picPrefix + fileInfo.data.picThumbW1080;
          //     }

          //     this.listPictureActivity[i].pictureInfo.push(listPicAct);
          //   }
          // }
        }
        console.log(this.listPictureActivity)

        this.isRefresh = false;
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false;
      }
    },
    //获取个人图集
    async searchAtlasAsync (val) {
      let { status, data, message, errors } = await searchAtlas(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          this.myAtlas.push({
            name: '[' + (data[i].libInfo ? data[i].libInfo.name : '暂无') + '] ' + data[i].name,
            date: formatConversion(data[i].createAt.toString()),
            libId: data[i].libId,
            atlasId: data[i].id
          });

        }
        // this.myAtlasId = this.myAtlas[0].label;
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //设置选中图片
    async setUserSettingAsync (val, val2, data1) {
      let { status, data, message, errors } = await setUserSetting(val, val2, data1);
      if (status) {
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取选中图片
    // async getUserSettingAsync (val, val2) {
    //   let { status, data, message, errors } = await getUserSetting(val, val2);
    //   return
    //   if (status) {
    //     let choosePic = JSON.parse(data)
    //     if (choosePic) {
    //       if (choosePic.value) {
    //         sessionStorage.setItem('picLove', choosePic.value)
    //       }
    //     }

    //   } else {
    //     let errortext = ''
    //     for (const key in errors) {
    //       errortext += errors[key]
    //     }
    //     this.$message.error({ message: message + errortext });
    //   }
    // },
    //获取选用图片
    async getUserSettingAsync (val, val2) {
      let { status, data, message, errors } = await getUserSetting(val, val2);
      if (status) {
        let piclove = JSON.parse(data);
        if (piclove) {
          if (piclove.value == null) {
            sessionStorage.removeItem("picLove");
          } else {

            let picIds = []
            for (let i = 0; i < piclove.value.length; i++) {
              picIds.push(piclove.value[i].id)
            }
            picIds = picIds.join(',');
            // console.log(picIds);
            let idsInfo = await getPictures({ ids: picIds });
            for (let j = 0; j < idsInfo.data.length; j++) {
              idsInfo.data[j].srcW1080 = this.picPrefix + idsInfo.data[j].fileInfo.picThumbW1080
              idsInfo.data[j].src = this.picPrefix + idsInfo.data[j].fileInfo.picThumbH160
            }
            // console.log(idsInfo.data);
            sessionStorage.setItem("picLove", JSON.stringify(idsInfo.data));
          }
        } else {
          sessionStorage.removeItem("picLove");
        }

      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

  },
  created () {



    window.onresize = () => {
      if (!checkFull()) {
        // 退出全屏后要执行的动作
        // console.log("退出全屏")
        this.seeFull = false;
      }
    }


    this.getUserSettingAsync(this.createUid, 'chooseWorkList')

    //获取屏幕的宽度来控制列表的间距
    this.displayResolution = document.documentElement.clientWidth;
    // if (powersObj.manageAllPictureActivity) {
    //   this.listPictureActivityAsync({ createUid: -1, pageSize: 100 });
    // } else if (powersObj.myPictureActivity) {
    //   this.listPictureActivityAsync({ createUid: 0, pageSize: 100 }); 
    // }else{
    //   this.$message.warning('获取活动列表失败！')
    // }

    this.listAccessByUidAsync({ uid: this.createUid })

    this.searchAtlasAsync({ pageSize: 20, page: 0, createUid: this.createUid })


    // this.timeInt = setInterval(() => {
    //   this.handleCurrentChange(this.currentPage);
    // }, 180000);


    // console.log(this.listPictureActivity)
  },
  mounted () {
    // window.addEventListener("scroll", this.scrollPic);
  },
  destroyed () {
    //离开这个界面之后，删除，不然会有问题
    // window.removeEventListener("scroll", this.scrollPic);
  },
  beforeDestroy () {
    // 组件销毁前调用
    // clearTimeout(this.timeInt);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./seeworkgroup.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}

// ::v-deep .el-select__caret:before {
//   content: "\e78f";
//   font-size: 16px;
//   color: black;
// }

.clearMar ::v-deep .el-dialog__body {
  padding: 0;
}
.ruku ::v-deep .el-dialog__body {
  padding: 0;
}

/*滚动条样式*/
::v-deep ::-webkit-scrollbar {
  width: 10px;
  /*height: 4px;*/
}
::v-deep ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
::v-deep ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}
.el-table ::v-deep .el-table__body tr td {
  cursor: pointer;
}
.el-table ::v-deep .el-table__body .current-row td {
  background-color: #929292 !important;
}
.el-table ::v-deep .el-table__body .current-row td .cell {
  color: #fff !important;
}
</style>
